const NotFound = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "60vh",
        textAlign: "center",
        padding: "18px"
      }}
    >
      <div style={{ fontSize: "72px", fontWeight: 700, lineHeight: 1 }}>
        404
      </div>
      <div style={{ fontSize: "20px", fontWeight: 600, margin: "16px 0 8px" }}>
        Page Not Found
      </div>
    </div>
  )
}

export default NotFound
